import React from 'react';
import PropTypes from 'prop-types';
import { HideOnMobile, ProgressBar } from '@web/atoms';
import { BaseHeader, PromoPill } from '@web/molecules';
import {
  BreadcrumbContainer,
  CurrentProgress,
  PromoPillContainer,
} from './styles';

export const QuizHeader = ({ currentStep, totalSteps }) => {
  const rightHeaderSegment = (
    <HideOnMobile>
      <PromoPillContainer>
        <PromoPill />
      </PromoPillContainer>
    </HideOnMobile>
  );

  const topHeaderSegment = (
    <>
      <ProgressBar
        currentStep={currentStep}
        totalSteps={totalSteps}
        labelText={`Signup step ${currentStep} of ${totalSteps}`}
      />
      <BreadcrumbContainer>
        <CurrentProgress>
          Pup Quiz ({currentStep}/{totalSteps})
        </CurrentProgress>
      </BreadcrumbContainer>
    </>
  );

  return (
    <BaseHeader
      topSegment={topHeaderSegment}
      rightSegment={rightHeaderSegment}
    />
  );
};

QuizHeader.displayName = 'QuizHeader';

QuizHeader.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};
